import { render, staticRenderFns } from "./customizations.vue?vue&type=template&id=0f7471a2&"
import script from "./customizations.vue?vue&type=script&lang=js&"
export * from "./customizations.vue?vue&type=script&lang=js&"
import style0 from "./customizations.vue?vue&type=style&index=0&id=0f7471a2&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports